module.exports = __webpack_public_path__ + "static/img/index1(1)_13.780fa1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index1(1)_13.png
// module id = 3119
// module chunks = 1